import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Star } from 'lucide-react-native';
import { memo, useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** Three stars; the earned ones land one after another. */
export const StarRow = memo(
  ({ stars, size }: { stars: number; size: number }) => {
    const { rpx } = useResponsiveContext();
    const pops = useRef([0, 1, 2].map(() => new Animated.Value(0))).current;
    useEffect(() => {
      Animated.stagger(
        220,
        pops.map(value =>
          Animated.spring(value, {
            toValue: 1,
            friction: 4,
            useNativeDriver: true,
          }),
        ),
      ).start();
    }, [pops]);
    return (
      <View style={{ flexDirection: 'row', gap: rpx(4) }}>
        {pops.map((pop, i) => (
          <Animated.View
            key={i}
            style={{
              transform: [
                {
                  scale: pop.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0.4, 1],
                  }),
                },
              ],
            }}
          >
            <Star
              size={size}
              color={i < stars ? aiColors.amber : aiColors.border}
              fill={i < stars ? aiColors.amber : 'transparent'}
            />
          </Animated.View>
        ))}
      </View>
    );
  },
);
